import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Dashboard } from "./Dashboard";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "APPOINTMENTS_APPROVE",
    applicationRights: Rights,
    title: 'Godkjenn frav&aelig;r',
    text: 'Godkjenn frav&aelig;r',
    icon: 'calendar-check',
    url: "/appointments-approve",
    sequenceNo: 17200,
    routes: Routes,
    dashboard: Dashboard
})
